<!--
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-09-11 10:58:20
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-11 10:59:53
 * @FilePath: /vue_huaqiang/src/views-oms/collection-management/temp/temp.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="padding:30px;">
      <transition
        name="fade-transform"
        mode="out-in"
      >
        <router-view />
      </transition>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: 'temp'
})
export default class extends Vue {
}
</script>
